import React,{useState,useEffect} from 'react'
import { IdListPageStyle } from './IdListInput.styled';
import EditInput from './EditInput';

const EditListInput = ({ ids=[],title="",loading="Loading ...",onDelete }) => {
  
  const [dataList, setDataList] = useState(ids)

  useEffect(() => {
    
    setDataList(ids)
    
  }, [ids])
  

  
  return (
    <IdListPageStyle>
      <div className='edit-div'>
        { ids.length===0
          ?
          <p className='loading-div'>{loading}</p>
          :
          dataList.map((id, index) => (
            <EditInput item={id} onDelete={(item)=>onDelete(item)} index={index} title={title} key={index} />
          ))
        }
      </div>
      
    </IdListPageStyle>
  );
};

export default EditListInput